import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  useMediaQuery,
  makeStyles,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import arrow from 'images/arrow-button.svg';
import commonStyles from './styles.scss';

const useStyles = makeStyles((theme) => ({
  panel: {
    backgroundColor: theme.colors.whiteGrey,
    boxShadow: 'none',
    position: 'inherit',
    '&$expanded': {
      margin: 0,
    },
  },
  expanded: {},
  summary: {
    padding: '35px 0',
    width: '90%',
    margin: 'auto',
    borderTop: theme.borders.greyBorder(false),
    '&$expanded': {
      minHeight: '48px',
    },
  },
  summaryContent: {
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '20px 0',
    '&$expanded': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  summaryButtonWrapper: {
    position: 'absolute',
    bottom: '35px',
  },
  panelDetails: {
    padding: 0,
    width: '90%',
    margin: 'auto',
  },
}));

const GenericBlock = ({ children, title }) => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (isMobile) {
    return (
      <ExpansionPanel
        classes={{
          root: classes.panel,
          expanded: classes.expanded,
        }}
      >
        <ExpansionPanelSummary
          classes={{
            root: classes.summary,
            content: classes.summaryContent,
            expanded: classes.expanded,
          }}
          expandIcon={<img src={arrow} alt="expand" />}
        >
          <span className={commonStyles.blockHeaderText}>{title}</span>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails classes={{ root: classes.panelDetails }}>
          {children}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }

  return <Fragment>{children}</Fragment>;
};

GenericBlock.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default GenericBlock;
